import { LuX } from "react-icons/lu";

export function AttachedImageIcon({
  attachedImg,
  onRemove,
}: {
  attachedImg: File;
  onRemove: () => void;
}) {
  return (
    <div className="relative">
      <img
        src={URL.createObjectURL(attachedImg)}
        alt="Attached"
        className="w-8 h-8 rounded object-contain 
            bg-black/5 dark:bg-white/10"
      />
      <button
        onClick={onRemove}
        className="absolute -top-1 -right-1 bg-red-500 rounded-full p-0.5"
      >
        <LuX className="w-3 h-3 text-white" />
      </button>
    </div>
  );
}
